var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as React from 'react';
import { inject } from 'mobx-react';
import { ViewLarge, ViewSmall, Viewport } from '@shared-ui/viewport-context';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { UitkSpacing } from 'uitk-react-spacing';
import { getHeaderData } from '../gc-section-data';
import { HeaderMinimalToolbar } from './partners/header-minimal-toolbar';
import { HeaderMinimalTemplateC } from './partners/header-minimal-template-c';
import { HeaderImageToolbar } from '../header-image-toolbar';
import { HeaderNavToolbar } from './partners/header-nav-toolbar';
import { BaseHeader } from './header-elements/base-header';
import { SubHeader } from './header-elements/sub-header';
import { HeaderRegion } from './header-elements/header-region';
import { HeaderLanguagesToolbar } from './partners/header-language-toolbar';
import { HeaderText } from './partners/header-text';
import { ExternalScripts } from './header-elements/external-scripts';
import { SecondaryHeaderRegion } from './header-elements/secondary-header-region';
import { BSABanner } from '../bsa-banner';
import { EGStripe } from '../eg-stripe';
var TemplateC = /** @class */ (function (_super) {
    __extends(TemplateC, _super);
    function TemplateC() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TemplateC.prototype.render = function () {
        var _a = this.props, globalComponentsContext = _a.globalComponentsContext, minimal = _a.minimal;
        var className = 'global_navigation__header__default__max_width';
        var headerData = getHeaderData(globalComponentsContext);
        var languages = (globalComponentsContext
            && globalComponentsContext.header
            && globalComponentsContext.header.partnerSupportedLanguages)
            || null;
        var bsa = headerData.bsa;
        if (minimal) {
            return (React.createElement(React.Fragment, null,
                React.createElement(EGStripe, null),
                React.createElement(HeaderMinimalTemplateC, { headerData: headerData })));
        }
        return (React.createElement(React.Fragment, null,
            React.createElement(EGStripe, null),
            bsa && React.createElement(BSABanner, { bsa: bsa }),
            React.createElement(Viewport, null,
                React.createElement(ViewSmall, null,
                    React.createElement(HeaderMinimalToolbar, { headerData: headerData })),
                React.createElement(ViewLarge, null,
                    React.createElement(React.Fragment, null,
                        React.createElement(HeaderRegion, null,
                            React.createElement(UitkSpacing, { padding: { inlinestart: 'six', inlineend: 'two' } },
                                React.createElement(BaseHeader, { className: className },
                                    React.createElement("div", null,
                                        React.createElement(HeaderImageToolbar, { headerImg: headerData.headerImg })),
                                    React.createElement(UitkLayoutFlex, { alignItems: "center", className: "global-nav-header-links__nav" },
                                        React.createElement(UitkLayoutFlexItem, null,
                                            React.createElement(HeaderLanguagesToolbar, { languages: languages })),
                                        React.createElement(UitkLayoutFlexItem, null,
                                            React.createElement(HeaderNavToolbar, { numberOfLinks: 0, menuLinks: headerData.navLinks })))))),
                        React.createElement(SecondaryHeaderRegion, null,
                            React.createElement(UitkSpacing, { padding: { inlinestart: 'six', inlineend: 'two' } },
                                React.createElement(SubHeader, { className: className },
                                    React.createElement("div", null,
                                        React.createElement(HeaderImageToolbar, { headerImg: headerData.coBrandImg, isPoweredBy: true })),
                                    React.createElement(UitkLayoutFlex, null,
                                        React.createElement(HeaderText, { headerText: headerData.loyaltyText, headerItems: headerData.loyaltyItems })),
                                    React.createElement(UitkSpacing, { padding: { inlinestart: 'three' } },
                                        React.createElement("div", { className: "sub-header__nav loyalty-cobrand-header-links" },
                                            React.createElement(UitkLayoutFlex, null,
                                                React.createElement(HeaderNavToolbar, { numberOfLinks: 0, menuLinks: headerData.secondaryNavLinks })))))))))),
            React.createElement(ExternalScripts, __assign({}, globalComponentsContext.header))));
    };
    TemplateC = __decorate([
        inject('globalComponentsContext', 'experiment')
    ], TemplateC);
    return TemplateC;
}(React.Component));
export { TemplateC };
//# sourceMappingURL=template-c.js.map